import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-category-box',
  templateUrl: './category-box.component.html',
  styleUrl: './category-box.component.scss'
})
export class CategoryBoxComponent {

  @Input() category: any;
}
